var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton px-4 py-4 d-flex"},[_c('v-skeleton-loader',{attrs:{"type":"avatar"}}),_c('v-skeleton-loader',{staticClass:"ml-3",attrs:{"width":"100px","type":"text@2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }